import React from "react";
import { makeStyles } from "tss-react/mui";
import { MenuItem, TextField } from "@mui/material";
import { useField } from "formik";
import { useIntl } from "react-intl";
import { OPERATORS } from "../../constants";
import { formInputsStyles } from "../../Configuration/styles";

const useStyles = makeStyles()(() => ({
  input: {
    "& .MuiInputLabel-root": {
      overflow: "visible",
    },
    "& .MuiSelect-select": {
      padding: "7.5px 14px",
    },
  },
}));

export const KpiOperatorField = () => {
  const intl = useIntl();
  const { classes } = useStyles();
  const inputStyles = formInputsStyles();
  const [field, meta] = useField("operator");

  return (
    <div className={classes.input} style={{ flex: "0 0 64px" }}>
      <TextField
        className={inputStyles.classes.inputText}
        variant="outlined"
        fullWidth
        error={!!(meta.touched && meta.error)}
        helperText={meta.touched && meta.error}
        label={intl.formatMessage({ id: "OPERATOR" })}
        select
        {...field}
      >
        {OPERATORS.map((op) => (
          <MenuItem key={op.name} value={op.name}>
            {op.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};
